export default "__VITE_ASSET__BBFyVZpX__"